import axios from "axios";
import accessToken from "../jwt-token-access/accessToken";

//pass new generated access token here
const token = accessToken;

//apply base url for axios
// const API_URL = "http://192.168.1.6:8060";
//  const API_URL = "http://localhost:8060";
// const API_URL = "http://172.25.5.175:8060";
const API_URL = "https://api.supporthqmanager.com";

const axiosApi = axios.create({
  baseURL: API_URL,
  mode: 'no-cors',
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    // 'Content-Type': 'multipart/form-data',
    // 'Content-Type': 'application/x-www-form-urlencoded'
  },
});

//axiosApi.defaults.headers.common["Authorization"] = token;

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response.data);
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function put(url, data, config = {}) {
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data);
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => response.data);
}


export function apiURL (){
  return API_URL
}